import { get } from 'lodash-es';
import { emptyArray } from 'ui-components/default-props/empty';

const ADDRESS_UNVERIFIED = 'Unverified';
const ADDRESS_VERIFIED = 'Verified';
const ADDRESS_WARNING = 'Warning';
const ADDRESS_ERROR = 'Error';
const SHIP_TO_RESIDENTIAL = 'Residential';
const SHIP_TO_COMMERCIAL = 'Commercial';

// unfortunate that we overlap verified/validated terms so sticking with the enum values supplied
export const getShipmentCollectionAddressVerificationMeta = (shipmentCollection) => {
  const verifiedShipments = shipmentCollection.filter((shipment) => get(shipment, 'shipToVerificationStatus') === ADDRESS_VERIFIED);
  const domesticResidentialVerified = verifiedShipments.filter(
    (shipment) => get(shipment, 'shipToResidentialIndicator') === SHIP_TO_RESIDENTIAL,
  ).length;
  const domesticCommercialVerified = verifiedShipments.filter(
    (shipment) => get(shipment, 'shipToResidentialIndicator') === SHIP_TO_COMMERCIAL,
  ).length;
  const internationalVerified = verifiedShipments.filter((shipment) => get(shipment, 'shipToIsDomestic') === false).length;
  const addressUnverified = shipmentCollection.filter(
    (shipment) => get(shipment, 'shipToVerificationStatus') === ADDRESS_UNVERIFIED,
  ).length;
  const addressWarning = shipmentCollection.filter((shipment) => get(shipment, 'shipToVerificationStatus') === ADDRESS_WARNING).length;
  const addressError = shipmentCollection.filter((shipment) => get(shipment, 'shipToVerificationStatus') === ADDRESS_ERROR).length;

  return {
    domesticResidentialVerified,
    domesticCommercialVerified,
    internationalVerified,
    addressUnverified,
    addressWarning,
    addressError,
  };
};

export const addSingleValidatedAddressToOrder = (address, salesOrder) => {
  if (address.status === 'Error' || address.status === 'Warning') {
    const message = get(address, 'messages.0');
    const status = address.status === 'Error' ? 'ERR' : 'WRN';
    const currentAddress = salesOrder.shipTos[0];
    return {
      ...salesOrder,
      shipTos: [
        {
          ...currentAddress,
          verificationStatus: status,
          verificationMessage: message,
        },
      ],
    };
  }

  if (address.status !== 'Verified') {
    return salesOrder;
  }

  const { matchedAddress } = address;
  if (!matchedAddress) {
    return salesOrder;
  }

  const currentAddress = salesOrder.shipTos[0];
  const verifiedAddress = {
    name: currentAddress.name,
    phone: currentAddress.phone,
    ...matchedAddress,
    verificationStatus: 'VER',
    residentialIndicator: matchedAddress.isResidential ? 'Residential' : 'Commercial',
  };
  return {
    ...salesOrder,
    shipTos: [verifiedAddress],
  };
};

const trimAndCombine = (...addressLine) => {
  return addressLine.reduce((acc, current) => {
    if (!current) {
      return acc;
    }
    return acc.length ? `${acc}, ${current.trim()}` : current.trim();
  }, '');
};

export const transformAddressIntoOneLine = (address) => {
  const { company, line1, line2, city, state, postalCode, countryCode } = address;
  return trimAndCombine(company, line1, line2, city, state, postalCode, countryCode);
};

export const buildAddressSalesOrderArray = (orders) => {
  return orders
    .map((order) => {
      const salesOrderId = get(order, 'salesOrder.salesOrderId', 0);
      const shipTos = get(order, 'salesOrder.shipTos', emptyArray);
      return shipTos.map((shipTo) => ({
        address: transformAddressIntoOneLine(shipTo),
        salesOrderId,
        name: shipTo.name,
        company: shipTo.company,
        phone: shipTo.phone,
      }));
    })
    .reduce((acc, shipTo) => acc.concat(shipTo), emptyArray);
};

export const isResidentialAddress = (residentialIndicator) => {
  return residentialIndicator === SHIP_TO_RESIDENTIAL;
};

export const isAddressEmpty = (address) => {
  const { city, state, postalCode } = address;
  return (city === null || city === '') && (state === null || state === '') && (postalCode === null || postalCode === '');
};
